import { AfterViewInit, Component, Input } from '@angular/core';
import { Toast, ToastService } from '@app/notifications/toast.service';

@Component({
  selector: 'acs-toast',
  template: `
    <div class="toast-container" id="toast-container">
      <div
        *ngFor="let toast of toasts; let i = index"
        [class]="'toast-content ' + toast.type"
        id="toast-content"
        (animationend)="onFadeOutDone($event, i)"
        [style.animation-delay]="'0s, ' + toast.animationDelay + 'ms'"
      >
        <div class="icon-container" *ngIf="toast.icon">
          <mat-icon
            aria-hidden="false"
            class="fa fa-type d-flex justify-content-center"
            [class]="toast.icon"
          ></mat-icon>
        </div>
        <div class="text-container ms-1">
          <div *ngFor="let item of toast.items" class="toast-item" id="toast-item">
            <div class="toast-title">{{ item.title }}</div>
            <div class="toast-message">{{ item.message }}</div>
          </div>
        </div>
        <button style="pointer-events: all" mat-icon-button type="button" (click)="closeToast(i)">
          <mat-icon class="fa fa-close"></mat-icon>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./toast.component.scss'],
  //animations: doesn't work because use noopanimationsmodule
  standalone: false
})
export class ToastComponent implements AfterViewInit {
  @Input() toasts: Toast[];
  @Input() styles: Map<string, Map<string, string>>;

  constructor(private toastService: ToastService) {}

  ngAfterViewInit(): void {
    this.applyCustomStyles();
  }

  public closeToast(index: number): void {
    console.log('close', index);
    this.toasts.splice(index, 1);

    if (this.toasts.length === 0) {
      this.toastService.removeToast();
    }
  }

  public onFadeOutDone(event: AnimationEvent, i: number) {
    if (event.animationName.toLowerCase().includes('fadeout')) {
      this.closeToast(i);
    }
  }

  private applyCustomStyles(): void {
    if (this.styles && this.styles.size > 0) {
      for (const style of this.styles.entries()) {
        const element = document.getElementById(style[0]);
        if (element) {
          for (const cssValues of style[1].entries()) {
            element.style[cssValues[0]] = cssValues[1];
          }
        }
      }
    }
  }
}
